import React, { useContext, useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';

import { get } from 'lodash';

import axios from 'axios';

import {
  importData,
  setUserRoles,
  setSelectedUserId,
  setOwnCvId,
  setOwnUserInfo,
  setResumeItems,
  setActiveResume,
  roles,
  isUserRoleAvailable,
  setUserTenants,
} from '../../utils';

import { postDataLogin } from '../../services/api';
import { changeLoggedIn } from '../../actions';
import AppContext from '../../context/AppContext';
import { errorToast, infoToast } from '../../shared/toast';
import Loading from '../Loading/loading';

export const authLink = `${import.meta.env.REACT_APP_AUTH_MODULE}#/auth?redirect=${
  import.meta.env.REACT_APP_REDIRECT_URL
}&env=${import.meta.env.REACT_APP_AUTHORIZE_ENV}`;

const Login = (props) => {
  const [staticsEmail, setStaticsEmail] = useState(null);
  const context = useContext(AppContext);
  const { dispatch } = context;

  const history = useHistory();
  const { loggedIn } = props;
  let queryUserName;

  // eslint-disable-next-line react/destructuring-assignment
  if (props.location.state) {
    const query = new URLSearchParams(props.location.state.from.search);
    queryUserName = query.get('username');
  }

  const loginUser = () => {
    postDataLogin()
      .then((res) => {
        if (res.error) {
          infoToast('Session expired. Please re-login to renew your session.');
        } else if (get(res, 'user.resume_items', []).length === 0) {
          errorToast('No CV found for your account. Please contact support.');
        } else {
          const resumeItems = get(res, 'user.resume_items');
          let mainCvItem = resumeItems.find((item) => item.isMain === true);
          if (!mainCvItem) {
            mainCvItem = resumeItems[0];
          }
          const buf = mainCvItem.user;
          mainCvItem.user = {
            _id: buf,
            id: buf,
            team_manager: get(res, 'user.team_manager._id'),
            username: get(res, 'user.username'),
          };
          if (!queryUserName) {
            importData(dispatch, { data: { ...mainCvItem } });
            setSelectedUserId(dispatch, null);
          }
          const userInfo = {
            userId: res?.user?.id || '',
            username: res?.user?.username || '',
            email: res?.user?.email || '',
            personId: res?.user?.personId || '',
          };
          setResumeItems(dispatch, resumeItems);
          setOwnUserInfo(dispatch, userInfo);
          setOwnCvId(dispatch, mainCvItem.id);
          setActiveResume(dispatch, mainCvItem.id);
          checkRole(res);
          setUserTenants(dispatch, get(res, 'userTenants'));
          props.changeLoggedIn(true);
        }
      })
      .catch((error) => {
        errorToast(`Login failed: ${error.message}`);
      });
  };

  useEffect(() => {
    if (import.meta.env.REACT_APP_LOCAL) {
      setStaticsEmail(import.meta.env.REACT_APP_LOCAL);
    } else {
      axios
        .get(`${import.meta.env.REACT_APP_STATICS}/api/user/info`, { withCredentials: true })
        .then((res) => {
          if (res.data.email) {
            setStaticsEmail(res.data.email);
          } else {
            window.location.href = authLink;
          }
        })
        .catch((err) => {
          window.location.href = authLink;
          console.log(err);
        });
    }
  }, [loggedIn]);

  useEffect(() => {
    if (staticsEmail) {
      loginUser();
    }
    // eslint-disable-next-line
  }, [staticsEmail]);

  if (loggedIn) {
    const { from } = props.location.state || { from: { pathname: '/' } };
    return <Redirect to={from} />;
  }

  const checkRole = (res) => {
    const userRoles = get(res, 'roles');
    const isHighRoles = isUserRoleAvailable(userRoles, [
      roles.SUPERUSER,
      roles.BENCH_MANAGER,
      roles.SALE_MANAGER,
      roles.LEAD_SALE_MANAGER,
      roles.PROJECT_MANAGER,
      roles.LEAD_SALE_MANAGER_READONLY,
      roles.RECRUITER,
      roles.LEAD_RECRUITER,
      roles.RESEARCHER,
      roles.CTO,
      roles.PEOPLE_MANAGER,
      roles.DEPUTY_PEOPLE_MANAGER,
      roles.TEAM_MANAGER,
    ]);

    setUserRoles(dispatch, userRoles);

    if (!!queryUserName && res.user.username !== queryUserName && !isHighRoles) {
      history.push('/');
      infoToast(
        'Sorry, your role does not have access to this page. Please contact the administrator.',
      );
    }
  };

  return <Loading />;
};
export default connect(
  (state) => ({
    loggedIn: state.loggedIn,
  }),
  {
    changeLoggedIn,
  },
)(Login);
